<template>
    <div>
        <ProgressBar :progress-value="progressValue" is-animated/>

        <div class="back-button">
            <b-button @click="goBack">
                <font-awesome-icon :icon="['fas', 'chevron-left']"/>
                Zurück
            </b-button>
        </div>

        <b-form @submit="onSubmit">
            <b-table
                    :busy="axiosLoading"
                    :fields="fields"
                    :items="items"
                    hover
                    responsive
                    stacked="sm"
                    striped>
                <template v-slot:table-busy>
                    <div class="text-center text-secondary my-2">
                        <b-spinner class="align-middle" type="grow"/>
                    </div>
                </template>
                <template v-slot:cell(question)="data">
                    <!-- If/else is needed because not every Interest has a defined text/question. -->
                    <span v-if="data.item.text !== null">{{ data.item.text }}</span>
                    <span v-else>{{ data.item.name }}</span>
                    <i :title="'Platzhalter-Beschreibung: ' + data.item.description" class="zhaw-tooltip" v-b-tooltip.hover>
                        <font-awesome-icon :icon="['fas', 'info-circle']"/>
                    </i>
                </template>
                <template v-slot:cell(option1)="data">
                    <label>
                        <b-form-radio :name="data.item.name" :value="0" v-model="selectedRatings[data.index]" required/>
                    </label>
                </template>
                <template v-slot:cell(option2)="data">
                    <label>
                        <b-form-radio :name="data.item.name" :value="1" v-model="selectedRatings[data.index]" required/>
                    </label>
                </template>
                <template v-slot:cell(option3)="data">
                    <label>
                        <b-form-radio :name="data.item.name" :value="2" v-model="selectedRatings[data.index]" required/>
                    </label>
                </template>
                <template v-slot:cell(option4)="data">
                    <label>
                        <b-form-radio :name="data.item.name" :value="3" v-model="selectedRatings[data.index]" required/>
                    </label>
                </template>
                <template v-slot:cell(option5)="data">
                    <label>
                        <b-form-radio :name="data.item.name" :value="4" v-model="selectedRatings[data.index]" required/>
                    </label>
                </template>
            </b-table>

            <CancelButton router-link="/start"/>
            <b-button @click="saveInterests" to="/ergebnisse" v-if="resultIsReady && lastInterestQuestions"
                      variant="primary">
                <font-awesome-icon :icon="['fas', 'poll-h']"/>
                Ergebnis anzeigen
            </b-button>
            <b-button @click="saveInterests" to="/ergebnisse" v-if="resultIsReady && !lastInterestQuestions">
                <font-awesome-icon :icon="['fas', 'poll-h']"/>
                Ergebnis anzeigen
            </b-button>
            <b-button type="submit" v-if="!lastInterestQuestions" variant="primary">
                <font-awesome-icon :icon="['fas', 'chevron-right']"/>
                Weiter
            </b-button>
        </b-form>
    </div>
</template>

<script>
    import {herokuApi, isUsingMockData, mockApi} from "../api/axiosConfig";
    import ProgressBar from "./helper-components/ProgressBar";
    import CancelButton from "./helper-components/CancelButton";
    import sharedStore from "../state-management/store";

    /* TODO: Maybe Refactoring this component to split the table and the view into two different components.
        Could lead to a easier & better State Management. */

    export default {
        name: "InterestForm",
        components: {CancelButton, ProgressBar},
        data() {
            return {
                fields: [
                    {key: 'question', label: 'Interessen'},
                    {key: 'option1', label: 'gar nicht', class: 'text-center'},
                    {key: 'option2', label: 'wenig', class: 'text-center'},
                    {key: 'option3', label: 'etwas', class: 'text-center'},
                    {key: 'option4', label: 'ziemlich', class: 'text-center'},
                    {key: 'option5', label: 'sehr', class: 'text-center'},
                ],
                items: [],
                selectedRatings: [],
                notAtAll: 'NotAtAll',
                littleBit: 'LittleBit',
                someBit: 'SomeBit',
                much: 'Much',
                veryMuch: 'VeryMuch',
                resultIsReady: false,
                lastInterestQuestions: false,
                axiosErrors: [],
                axiosHasError: false,
                axiosLoading: true
            }
        },
        computed: {
            /* Takes the initial Interest-Items Array and puts in the Likert-Values from the table. */
            itemsWithLikertValues: function () {
                this.items.forEach((obj, index) => {
                    obj.rating = this.selectedRatings[index]
                });
                return this.items
            },
            /* Enables a workaround for the form validation. */
            isFormComplete: function () {
                let selectedItems = [];
                this.items.forEach((obj, index) => {
                    selectedItems[index] = this.selectedRatings[index] >= 0 && this.selectedRatings[index] !== null;
                });
                return !selectedItems.includes(false);
            },
            progressValue: function () {
                return sharedStore.state.progressValue
            }
        },
        methods: {
            manageInterestsAndAdvance() {
                sharedStore.increaseProgressValue(10);
                sharedStore.increaseTableNumber(1);
                this.loadInterests();
                this.saveInterests();
                this.$router.push({name: 'interessen', params: {id: sharedStore.state.tableNumber.toString()}});
            },
            async loadInterests() {
                if (!isUsingMockData) {
                    /* GET interests (loads the interests to be shown in the table) */
                    await herokuApi
                        .get('/recommender/interests', {
                            params: {
                                page: sharedStore.state.tableNumber,
                                size: 5
                            }
                        })
                        .then(response => {
                            this.items = response.data.interests;
                            this.resultIsReady = response.data.hasResult;
                            this.lastInterestQuestions = response.data.lastInterests;
                            this.items.forEach((obj, index) => {
                                this.selectedRatings[index] = response.data.interests[index].rating;
                            });
                        })
                        .catch(error => {
                            this.axiosErrors.push(error);
                            this.axiosHasError = true
                        })
                        .finally(() => this.axiosLoading = false)
                } else {
                    await mockApi
                        .get('/interests.json')
                        .then(response => {
                            this.items = response.data.interests;
                            this.resultIsReady = response.data.hasResult;
                            this.lastInterestQuestions = response.data.lastInterests;
                        })
                        .catch(error => {
                            this.axiosErrors.push(error);
                            this.axiosHasError = true
                        })
                        .finally(() => this.axiosLoading = false)
                }
            },
            async saveInterests() {
                /* POST interests (saves the selected interests with their Likert-Values from the table) */
                await herokuApi
                    .post('/recommender/updateSession', this.itemsWithLikertValues) // Possible like this?
                    .then()
                    .catch(error => {
                        this.axiosErrors.push(error);
                        this.axiosHasError = true
                    })
                    .finally(() => this.axiosLoading = false);
                this.selectedRatings = [] // Reset array to the initial state.
            },
            goBack() {
                sharedStore.decreaseProgressValue(10);
                if (sharedStore.state.tableNumber > 1) { // Only reduce the tableNumber to the initial value 1 and not more, or it could load the interests when it's actually not needed.
                    sharedStore.decreaseTableNumber(1);
                    this.loadInterests();
                }
                this.$router.go(-1);
            },
            onSubmit(evt) {
                evt.preventDefault();
                this.manageInterestsAndAdvance();
            }
        },
        mounted() {
            // Initially load the interests when opening the Interest Table view/component for the first time.
            // Using a Workaround with setTimeout, because the /interests should not be loaded before /initSession is finished.
            setTimeout(this.loadInterests, 250)
        }
    }
</script>

<style scoped>
    label {
        width: 100%;
        height: 100%;
        cursor: pointer;
    }
</style>